<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" />
      </template>
    </template>
    <main class="common-main privacy">
      <div class="item">
        <h2 class="common-title">プライバシーポリシー</h2>
        <div class="item terms">
株式会社ZINE（以下，「当社」といいます。）は，本ウェブサイト上で提供するがん相談サービス「CancerWith」および「浜松オンラインがん相談 for 浜松医大」（以下,「本サービス」といいます。）における，本サービスにご登録いただいたユーザーの皆様（以下，「ユーザー」といいます。）の個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。
<br><br>
<h3>第１条（基本方針）</h3>
当社は，個人情報の保護に関する法令等および社内規程を遵守し，当社で取り扱う個人情報の取得および利用を適正に行うとともに，個人情報を安全かつ最新の状態で管理し，適正に廃棄することで，個人情報を保護します。
<br><br>
<h3>第２条（個人情報）</h3>
「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報および容貌，指紋，声紋にかかるデータ，および健康保険証の保険者番号等の当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
<br><br>
<h3>第３条（個人情報の取得方法）</h3>
当社は，ユーザーが利用登録をする際に氏名，生年月日，住所，電話番号，メールアドレス，銀行口座番号，クレジットカード番号，運転免許証番号等の個人情報をお尋ねすることがあります。また，ユーザーと提携先等との間でなされたユーザーの個人情報を含む取引記録や決済に関する情報を,当社の提携先（情報提供元，広告主，広告配信先等を含みます。以下，｢提携先｣といいます。）等から取得することがあります。
<br><br>
<h3>第４条（個人情報を収集・利用する目的）</h3>
当社が個人情報を収集・利用する目的は，以下のとおりです。

<ol>
<li>当社サービスの提供・運営のため</li>
<li>当社サービスを利用する際のログイン時又はログイン後の本人認証のため</li>
<li>ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）</li>
<li>ユーザーが利用中のサービスの新機能，更新情報，キャンペーン等および当社が提供する他のサービスの案内のメールを送付するため</li>
<li>メンテナンス，重要なお知らせ等必要に応じたご連絡のため</li>
<li>利用規約に違反したユーザーや，不正・不当な目的でサービスを利用しようとするユーザーの特定をし，ご利用をお断りするため</li>
<li>ユーザーにご自身の登録情報の閲覧や変更，削除，ご利用状況の閲覧を行っていただくため</li>
<li>有料サービスにおいて，ユーザーに利用料金を請求するため</li>
<li>当社サービス内に「相談例」として掲載し、サービスの利用を促すため（当社で個人が特定できないよう加工し、開示する情報に特定の個人が識別されるような情報は含みません）</li>
<li>投資家等に向けて行うプレゼンテーションのため（当社で個人が特定できないよう加工し、開示する情報に特定の個人が識別されるような情報は含みません）</li>
<li>当社が運営するオウンドメディア等への掲載のため（当社で個人が特定できないよう加工し、開示する情報に特定の個人が識別されるような情報は含みません）</li>
<li>キャンペーン等に当選されたユーザーへのご連絡のため</li>
<li>当社サービスの効果等に関する研究のため</li>
<li>その他当社の事業活動および市場調査に関する分析・統計のため</li>
<li>その他マーケティングに利用するため</li>
<li>その他上記業務に関連・付随する目的のため</li>
</ol>

<h3>第５条（利用目的の変更）</h3>
<ol>
<li>当社は，利用目的が変更前と関連性を有すると合理的に認められる場合に限り，個人情報の利用目的を変更するものとします。</li>
<li>利用目的の変更を行った場合には，変更後の目的について，当社所定の方法により，ユーザーに通知し，又は本ウェブサイト上に公表するものとします。</li>
</ol>

<h3>第６条（個人情報の管理）</h3>
当社は，個人情報の一部又は全部を含む資料，記憶媒体およびそれらの複写物等について，個人情報が不当に開示され又は漏洩されないよう，個人情報の管理に必要な措置を講じるものとします。
<br><br>
<h3>第７条（個人情報の第三者提供）</h3>
<ol>
<li>当社は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。</li>
<ol>
<li>人の生命，身体又は財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき</li>
<li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき</li>
<li>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
<li>予め次の事項を告知あるいは公表し，かつ当社が個人情報保護委員会に届出をしたとき</li>
<ol>
<li>利用目的に第三者への提供を含むこと</li>
<li>第三者に提供されるデータの項目</li>
<li>第三者への提供の手段又は方法</li>
<li>本人の求めに応じて個人情報の第三者への提供を停止すること</li>
<li>本人の求めを受け付ける方法</li>
</ol>
</ol>
<li>前項の規定は，次のいずれかに該当する場合には，適用しないものとします。</li>
<ol>
<li>当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合</li>
<li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
<li>個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名又は名称について，あらかじめ本人に通知し，又は本人が容易に知り得る状態に置いた場合</li>
</ol>
</ol>

<h3>第８条（個人情報の開示）</h3>
<ol>
<li>当社は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部又は一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。</li>
<ol>
<li>本人又は第三者の生命，身体，財産その他の権利利益を害するおそれがある場合</li>
<li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
<li>その他法令に違反することとなる場合</li>
</ol>
<li>前項の定めにかかわらず，履歴情報および特性情報等の個人情報以外の情報については，原則として開示いたしません。</li>
</ol>

<h3>第９条（個人情報の訂正および削除）</h3>
<ol>
<li>ユーザーは，当社の保有する自己の個人情報が誤った情報である場合には，当社が定める手続により，当社に対して個人情報の訂正，追加又は削除（以下，「訂正等」といいます。）を請求することができます。</li>
<li>当社は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正等を行うものとします。</li>
<li>当社は，前項の規定に基づき訂正等を行った場合，又は訂正等を行わない旨の決定をしたときは遅滞なく，これをユーザーに通知します。</li>
</ol>

<h3>第１０条（個人情報の利用停止等）</h3>
<ol>
<li>当社は，本人から，個人情報が利用目的の範囲を超えて取り扱われているという理由，又は不正の手段により取得されたものであるという理由により，その利用の停止又は消去（以下，「利用停止等」といいます。）を求められた場合には，当社が必要と判断した場合は，調査を行います。</li>
<li>前項の調査結果に基づき，その請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の利用停止等を行います。</li>
<li>当社は，前項の規定に基づき利用停止等を行った場合，又は利用停止等を行わない旨の決定をしたときは，遅滞なく，これをユーザーに通知します。</li>
<li>前２項の定めにかかわらず，利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じるものとします。</li>
</ol>

<h3>第１１条（アドバイザーによる個人情報の閲覧）</h3>
相談に回答するアドバイザー（以下，「アドバイザー」といいます。）は，ユーザーへの適切な回答を行うために必要な範囲内において，ユーザーの個人情報を閲覧することができるものとします。
<br><br>
<h3>第１２条（プライバシーポリシーの変更）</h3>
<ol>
<li>本ポリシーの内容は，法令その他本ポリシーに別段の定めのある事項を除いて，ユーザーに通知することなく，変更することができるものとします。</li>
<li>当社が別途定める場合を除いて，変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。</li>
</ol>

<h3>第１３条（お問い合わせ窓口）</h3>
本ポリシーに関するお問い合わせは，下記の窓口までお願いいたします。
<br><br>
株式会社ZINE CancerWith運営事務局<br>
<a href="https://share.hsforms.com/1X-5z7FfYQlSKleMOQ57vzA46sq5" target="_blank">お問い合わせフォーム</a>
<br><br>
<br><br>
2020年12月17日 制定<br>
2021年2月4日 改定<br>
2023年5月1日 改定<br>
2023年8月25日 改定
        </div>
      </div>
    </main>
    <FooterItem :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { Analytics/*, Logger*/ } from "aws-amplify"
import HeaderItem from './Header'
import FooterItem from './Footer'

//const logger = new Logger('Privacy');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'privacy',
  components: {
    HeaderItem,
    FooterItem
  },
  data() {
    return {
    }
  },
  async beforeCreate() {
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Privacy',
        url: window.location.origin + window.location.pathname
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      this.$gtag.pageview({
        page_path: '/privacy',
        page_title: 'プライバシーポリシー (/privacy)'
      })
    }
  }
}
</script>
